import styled from 'styled-components';
import Code from 'UIComponents/elements/Code';
import UIBadge from 'UIComponents/badge/UIBadge';
import { getBadgeColorByMethodName } from '../../config/methods';
import I18n from 'I18n';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';

/** The `UIGridItem` children. */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMethod = styled(UIBadge).withConfig({
  displayName: "EndpointComp__StyledMethod",
  componentId: "sc-1njz1wd-0"
})(["border-radius:20px;padding:4px 18px;font-size:14px;background-color:", ";"], ({
  method
}) => getBadgeColorByMethodName(method));
const StyledCode = styled(Code).withConfig({
  displayName: "EndpointComp__StyledCode",
  componentId: "sc-1njz1wd-1"
})(["background-color:transparent;padding:0 12px 4px 12px;word-break:break-word;display:flex;justify-content:space-between;padding-right:0;"]);
const StyledCopyButton = styled(UICopyButton).withConfig({
  displayName: "EndpointComp__StyledCopyButton",
  componentId: "sc-1njz1wd-2"
})(["&&{padding-top:6px;text-overflow:unset;overflow:hidden;}"]);
const Div = styled.div.withConfig({
  displayName: "EndpointComp__Div",
  componentId: "sc-1njz1wd-3"
})(["display:flex;flex-wrap:nowrap;align-items:baseline;"]);
const Endpoint = ({
  className,
  method,
  path
}) => {
  let copiedValue = path;
  if (!path.match(/^http(s)?/)) {
    copiedValue = `https://api.hubapi.com${path}`;
  }
  return /*#__PURE__*/_jsxs(Div, {
    className: className,
    children: [/*#__PURE__*/_jsx(StyledMethod, {
      method: method,
      children: method
    }), /*#__PURE__*/_jsx(StyledCode, {
      children: path
    }), /*#__PURE__*/_jsx(StyledCopyButton, {
      use: "transparent",
      tooltipPlacement: "right",
      truncate: false,
      value: copiedValue,
      responsive: false,
      hint: I18n.text('developer-docs-shared-components.tooltips.copyRequestUrl'),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "duplicate",
        screenReaderText: I18n.text('developer-docs-shared-components.tooltips.copyRequestUrl')
      })
    })]
  });
};
export default Endpoint;